module.exports = __webpack_public_path__ + "packs/media/images/avatars/avatar-432abd57e2845dd745382c0b50e64b5f.jpg";